import { ActivateInput } from '@/types'
import { request } from '@/store/client'

/**
  Activates a new user
* */
export const activateUser = (input: ActivateInput): Promise<any> => {
  return request({
    url: '/user/activate',
    method: 'post',
    data: input,
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 410) {
        throw new Error('TokenExpired')
      }

      if (error.response.status === 409) {
        throw new Error('TokenInvalid')
      }
    }

    throw error
  })

}
